import { component } from 'picoapp';
import Modal from 'utils/modal';
import { SwiperOptions } from 'swiper';

export default component(async (node) => {
  interface SliderConfig {
    slidesPerView: 'auto' | number
    allowTouchMove: boolean
    useNavigation: boolean
  }

  const sliderComponents = node.querySelectorAll<HTMLElement>('[data-slider-component]');
  const lightbox = node.querySelector<HTMLElement>('[data-lightbox]');
  const lightboxBtn = node.querySelector('[data-lightbox-btn]');
  const lightboxCloseBtn = node.querySelector('[data-lightbox-close-btn]');
  const lightboxImgWrappers = Array.from(node.querySelectorAll<HTMLElement>('[data-lightbox-img-wrapper]'));

  const thumbnailActiveClass = 'product__thumbnail--active';

  const initSliderComponents = async () => {
    const { default: Swiper, Navigation, Pagination } = (await import(
      /* webpackChunkName: "swiper" */
      'modules/swiper'
    ));

    sliderComponents.forEach((sliderComponent) => {
      const sliderElement = sliderComponent.querySelector<HTMLElement>('[data-slider]');
      const slides = sliderComponent.querySelectorAll('[data-slide]');
      const thumbnails = sliderComponent.querySelectorAll('[data-thumbnail]');

      const sliderConfig: SliderConfig = JSON.parse(sliderComponent.dataset.sliderConfig);
      const { slidesPerView, allowTouchMove, useNavigation } = sliderConfig;

      const prevBtn = sliderComponent.querySelector<HTMLElement>('[data-prev-btn]');
      const nextBtn = sliderComponent.querySelector<HTMLElement>('[data-next-btn]');

      const paignationElement = sliderComponent.querySelector<HTMLElement>('[data-slider-pagination]');

      const swiperOptions: SwiperOptions = {
        slidesPerView,
        allowTouchMove,
      };

      swiperOptions.modules = [Pagination];
      swiperOptions.pagination = {
        el: paignationElement,
        bulletClass: 'swiper-bullet',
        bulletActiveClass: 'swiper-bullet--active',
      };

      if (useNavigation) {
        swiperOptions.modules.push(Navigation);

        swiperOptions.navigation = {
          prevEl: prevBtn,
          nextEl: nextBtn,
          disabledClass: 'slider-arrow--disabled',
        };
      }

      const slider = new Swiper(sliderElement, swiperOptions);

      slider.on('slideChange', () => {
        const { activeIndex } = slider;

        thumbnails.forEach((thumb, index) => {
          thumb.classList[index === activeIndex ? 'add' : 'remove'](thumbnailActiveClass);
        });

        const slide = slides[activeIndex];
        const video = slide.querySelector('video');

        if (video) video.play();
      });

      thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          slider.slideTo(index);
        });

        thumb.addEventListener('mouseover', () => {
          slider.slideTo(index);
        });
      });
    });
  };

  const initLightbox = () => {
    document.body.appendChild(lightbox); // allow for full screen
    const modal = Modal(lightbox);

    lightboxBtn.addEventListener('click', () => modal.open());
    lightboxCloseBtn.addEventListener('click', () => modal.close());

    const initDriftZoom = async () => {
      const { default: Drift } = (await import(
        /* webpackChunkName: "drift" */
        'modules/drift'
      ));

      lightboxImgWrappers.forEach((imgWrapper) => {
        const img = imgWrapper.querySelector('img');

        (() => new Drift(img, {
          paneContainer: imgWrapper,
        }))();
      });
    };

    const centerImages = () => { // center image wrappers for mobile
      const interval = setInterval(() => {
        const hasLazyLoaded = lightboxImgWrappers.find((imgWrapper) => (
          imgWrapper.querySelector('img').classList.contains('lazyloaded')
        ));

        if (hasLazyLoaded) {
          clearInterval(interval);

          lightboxImgWrappers.forEach((imgWrapper) => {
            const posX = (imgWrapper.scrollWidth / 2) - (window.innerWidth / 2);
            const posY = (imgWrapper.scrollHeight / 2) - (window.innerHeight / 2);
            imgWrapper.scrollTo(posX, posY);
          });
        }
      }, 50);
    };

    modal.on('open', () => {
      centerImages();

      if (window.innerWidth >= 1024) {
        initDriftZoom();
      }
    });
  };

  const init = () => {
    initSliderComponents();
    initLightbox();
  };

  init();
});
